import { render, staticRenderFns } from "./SellerReclaimDetails.vue?vue&type=template&id=6b5c2b5c&"
import script from "./SellerReclaimDetails.vue?vue&type=script&lang=js&"
export * from "./SellerReclaimDetails.vue?vue&type=script&lang=js&"
import style0 from "./SellerReclaimDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports